export const getInviteMessage = (companyName?: string, openingTitle?: string | null): string => {
  if (openingTitle && companyName) {
    return `Hey!\n\nWe at ${companyName} reviewed your profile, and you seem to be a good fit for the role of ${openingTitle}.\n\nWould you be open to chatting about it?`;
  }

  if (openingTitle) {
    return `Hey!\n\nWe reviewed your profile, and you seem to be a good fit for the role of ${openingTitle}.\n\nWould you be open to chatting about it?`;
  }

  if (companyName) {
    return `Hey!\n\nWe at ${companyName} reviewed your profile, and you seem to be a good fit for one of our roles.\n\nWould you be open to chatting about it?`;
  }

  return 'Hey!\n\nWe reviewed your profile, and you seem to be a good fit for one of our roles.\n\nWould you be open to chatting about it?';
};
